import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { shellTokens } from '../../shell/theme/shellTheme';

const alertSx = (level) => {
    if (level === 'error') {
        return {
            borderColor: 'rgba(220, 38, 38, 0.3)',
            bgcolor: 'rgba(220, 38, 38, 0.05)',
        };
    }
    if (level === 'warn') {
        return {
            borderColor: 'rgba(217, 119, 6, 0.3)',
            bgcolor: 'rgba(217, 119, 6, 0.06)',
        };
    }
    return {};
};

const TodayAlerts = ({ alerts = [], loading }) => {
    if (loading) {
        return (
            <Box>
                {Array.from({ length: 3 }).map((_, index) => (
                    <Skeleton
                        key={index}
                        variant="rounded"
                        height={44}
                        sx={{ borderRadius: `${shellTokens.innerRadius}px`, mb: 1 }}
                    />
                ))}
            </Box>
        );
    }

    if (!alerts.length) {
        return (
            <Typography sx={{ fontSize: '0.82rem', color: shellTokens.muted }}>
                No actionable alerts — fleet looks healthy.
            </Typography>
        );
    }

    return (
        <Box>
            {alerts.map((alert) => (
                <Box
                    key={alert.id}
                    sx={{
                        display: 'flex',
                        gap: 1.25,
                        px: 1.5,
                        py: 1.25,
                        borderRadius: `${shellTokens.innerRadius}px`,
                        border: `1px solid ${shellTokens.border}`,
                        mb: 1,
                        fontSize: '0.82rem',
                        alignItems: 'flex-start',
                        ...alertSx(alert.level),
                    }}
                >
                    <Typography sx={{ fontSize: 'inherit', lineHeight: 1.45 }}>{alert.text}</Typography>
                </Box>
            ))}
        </Box>
    );
};

export default TodayAlerts;
